import { Badge, HStack, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { MdChevronLeft } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/Common/CustomButton";
import DateFormat from "../../../components/Common/DateFormat";
import { CommonTable } from "../../../components/CommonTable";
import { excelStatusColorMap, ExcelStatusData } from "./data";
import {
  selectExcelList,
  selectLoading,
  selectOrderBy,
  selectOrderDir,
  selectPageNo,
  selectPageSize,
  selectSearch,
  selectTotalRow,
} from "./redux/selector";
import { actions } from "./redux/slice";
import { IExcelListData } from "./types";


const ExcelList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const search = useSelector(selectSearch);
  const tableData = useSelector(selectExcelList);
  const loading = useSelector(selectLoading);
  const total = useSelector(selectTotalRow);
  const orderBy = useSelector(selectOrderBy);
  const orderDir = useSelector(selectOrderDir);

React.useEffect(() => {
  if (tableData) {
    console.log(tableData,"tableData");
  }


  return () => {
    
  }
}, [tableData])

  
  React.useEffect(() => {
    dispatch(actions.doGetExcelList());
    return () => {};
  }, [pageNo, pageSize, search, orderDir, orderBy]);

  const columnHelper = createColumnHelper<IExcelListData>();
  const columns = [
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.sNo")}`,
      cell: (info) => {
        return (
          <>
            {pageNo === 1 ? (
              <>{info.row.index + 1}</>
            ) : (
              <>{`${(pageNo - 1) * pageSize + info.row.index + 1}`}</>
            )}
          </>
        );
      },
    }),
    // columnHelper.accessor("fileName", {
    //   id: "fileName",
    //   header: `${t("common.list.title")}`,
    //   cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    // }),
    columnHelper.accessor("originalFileName", {
      id: "originalFileName",
      header: `${t("common.list.fileName")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    
   columnHelper.accessor("status", {
      id: "status",
      header: `${t("common.list.status")}`,
      cell: (info) => {
        const statusValue = info.getValue();
        const label = ExcelStatusData[statusValue] || "Unknown";
        const color = excelStatusColorMap[statusValue] || "gray";

        return (
          <Badge
            colorScheme={color}
            fontSize="md"
            fontWeight="500"
            sx={{ textTransform: "capitalize" }}
          >
            {t(label)}
          </Badge>
        );
      },
    }),

     columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: `${t("common.list.createdAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
       sortDescFirst: true,
    }),
    columnHelper.accessor("updatedAt", {
      id: "updatedAt",
      header: `${t("common.list.updatedAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
    }),
   
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.actions")}`,
      cell: (info) => {
        return (
          <HStack>
            <Tooltip label={`${t("order.list.view")}`}>
              <IconButton
                aria-label="view"
                icon={<RiEyeCloseLine />}
                onClick={() => {
                  navigate(`/admin/product/excel-list/${info.row.original._id}`);
                }}
              />
            </Tooltip>
          </HStack>
        );
      },
    }),
  ];
  if (tableData.length == 0) {
    return null
  }

  return (
    <>
      <CommonTable<IExcelListData>
        columns={columns}
        data={tableData}
        totalCount={total}
        pageNo={pageNo}
        pageSize={pageSize}
        search={search}
        loading={loading}
        onSearch={(v) => dispatch(actions.setSearch(v))}
        onPageChange={(p) => dispatch(actions.setPageNo(p))}
        onPageSizeChange={(s) => dispatch(actions.setPageSize(s))}
        onSortChange={(id, desc) => {
          dispatch(actions.setOrderBy(id));
          dispatch(actions.setOrderDir(desc ? "desc" : "asc"));
        }}
        hideAddButton
        filters={
          <CustomButton
            handleClick={() => {
              navigate(-1);
            }}
            title={t("common.button.back")}
            variant="brand"
            leftIcon={<MdChevronLeft />}
            isLeftIcon
          />
        }
      />
    </>
  );
};

export default ExcelList;
